export default "__VITE_PUBLIC_ASSET__9966fc63__"